<template>
  <v-container fill-height grid-list-lg wrap>
    <component :is="shownComponent" :content="content"/>
  </v-container>
</template>

<script>
import { db } from '@/firebase/config';
import PDF from '@/components/contents/pdf/index.vue';
import ImageGallery from '@/components/contents/image/index.vue';
import Folder from '@/components/contents/folder/index.vue';
import Loading from './loading';

export default {
  components: {
    PDF, Folder, ImageGallery, Loading,
  },
  mounted() {
    this.$bind('content', db.doc(`chapters/${this.$route.params.chapterID}/contents/${this.$route.params.contentID}`));
  },
  data: () => ({
    content: null,
  }),
  methods: {
    didTapItem(item) {
      this.$router.push(`${this.currentRoutePath}/conteudo/${item.id}`);
    },
  },
  computed: {
    shownComponent() {
      if (this.content) {
        if (this.content.type === 'pdf') {
          return PDF;
        }
        if (this.content.type === 'folder') {
          return Folder;
        }
        if (this.content.type === 'images') {
          return ImageGallery;
        }
      }
      return Loading;
    },
    icon() {
      if (this.chapter) {
        if (this.chapter.icon) {
          return this.chapter.icon;
        }
        return 'insert_drive_file';
      }
      return 'timer';
    },
    title() {
      if (this.chapter) {
        if (this.chapter.title) {
          return this.chapter.title;
        }
      }
      return 'Carregando...';
    },
  },
};
</script>
